import { Injectable } from '@angular/core';
import { UserService } from '../User/Service/user.service';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor(private userService: UserService) {}
  videoFormats = [
    '.MP4',
    '.MOV',
    '.WMV',
    '.AVI',
    '.AVCHD',
    '.FLV',
    '.F4V',
    '.SWF',
    '.MKV',
    '.WEBM',
    '.WAV',
  ];
  imageFormates = ['.gif', '.jpeg', '.jpg', '.png', '.webp', '.jfif', '.svg', '.GIF', '.JPEG', '.JPG', '.PNG', '.WEBP', '.JFIF', '.SVG'];
  audioFormates = ['.mp3', '.aif', '.wav', '.MP3', '.AIF', '.WAV'];
  isVideo = (file) =>
    this.videoFormats.some((i) => file?.toUpperCase().includes(i));

  isImage = (file) =>
    this.imageFormates.some((i) => file?.toLowerCase().includes(i));

  isAudio = (file) =>
    this.audioFormates.some((i) => file?.toLowerCase().includes(i));

  isPdf = (file) => file?.toLowerCase().includes('.pdf');

  getSupportedMimeTypes() {
    const possibleTypes = [
      'video/mp4',
      'video/webm;codecs=vp9,opus',
      'video/webm;codecs=vp8,opus',
      'video/webm;codecs=h264,opus',
    ];
    return possibleTypes.filter((mimeType) => {
      return MediaRecorder.isTypeSupported(mimeType);
    });
  }
  getVideoExtension() {
    if (MediaRecorder.isTypeSupported('video/mp4')) {
      return '.mp4';
    } else {
      return '.webm';
    }
  }
  get isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
  getSupportedMimeTypeOptions(isAudio = false) {
    if (isAudio && !this.isSafari) return { mimeType: 'audio/wav' };
    if (isAudio) {
      if (MediaRecorder.isTypeSupported('audio/mp4')) return { mimeType: 'audio/mp4' };
      if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) return { mimeType: 'audio/webm;codecs=opus' };
      return {};
    }
    let options = {};
    if (MediaRecorder.isTypeSupported('video/mp4')) {
      options = { mimeType: 'video/mp4', videoBitsPerSecond: 500000 };
    } else {
      options = {
        mimeType: this.getSupportedMimeTypes()[0],
        videoBitsPerSecond: 1000000,
      };
    }
    return options;
  }
}
